<template>
  <div class="van-page">
    <the-header title="5分钟办件" />
    <gz-footer></gz-footer>
    <van-sticky>
      <van-search class="search-box" v-model="keyword" placeholder="项目名称或项目代码" shape="round"></van-search>
      <div class="van-filter">
        <van-dropdown-menu active-color="#427AF4">
          <van-dropdown-item title="查询类型" v-model="form.blzt" :options="typeRadio" />
          <van-dropdown-item :title="form.orgName || '办理部门'" ref="department" @click="close1">
            <div class="popup-body" id="department1">
              <van-cascade-select :list="regionList" data-key="name" @clickItem="onClick1" @confirm="onComfirm1"
                @close="close1" />
            </div>
          </van-dropdown-item>
          <van-dropdown-item title="所属阶段">
            <div class="popup-body">
              <van-radio-group v-model="form.stageId">
                <van-radio :name="item.id" v-for="(item, index) in stageRadio" :key="index" style="width: 50%;">{{
                  item.name }}</van-radio>
              </van-radio-group>
            </div>
          </van-dropdown-item>
          <van-dropdown-item title="时间区域" ref="refItemCalendar">
            <van-calendar title="时间区域" type="range" color="#427AF4" :poppable="false" :style="{ height: '450px' }"
              :min-date="minDate" :max-date="maxDate" @confirm="confirmCalendar" />
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </van-sticky>
    <van-list class="van-container" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDataList">
      <div class="van-section" v-for="(item, index) in listData" :key="index">
        <div class="van-section__header">
          <div class="van-section__title">{{ item.SPSXMC }}</div>
          <div class="van-section__time">用时 <em>{{ item.HANDLE_SECOND }}s</em></div>
        </div>
        <van-cell-group :border="false">
          <van-cell :border="false" title="项目名称" :value="item.XMMC" value-class="text-black"></van-cell>
          <van-cell :border="false" title="工程代码" :value="item.GCDM" value-class="text-black"></van-cell>
          <van-cell :border="false" title="审批部门" :value="item.SPBMMC"></van-cell>
          <van-cell :border="false" title="受理时间" :value="item.startTime"></van-cell>
          <van-cell :border="false" title="办结时间" :value="item.completed"></van-cell>
        </van-cell-group>
      </div>
    </van-list>
    <van-popup v-model="areas.visible" position="bottom">
      <van-area title="请选择地区" :area-list="areas.datagram" value="110101" @confirm="handleAreaConfirm"
        @cancel="handleAreaCancel" />
    </van-popup>
  </div>
</template>
  
<script>
import { areaList } from '@vant/area-data';
import { wfzbj } from '@/api/interface/5min.js'
import { getOrgInfo } from '@/api/interface/home.js'
import moment from 'moment'
import { Loading } from 'element-ui';
export default {
  components: {
    'the-header': () => import('@/components/TheHeader'),
    'gz-footer': () => import('@/components/GzFooter'),
  },
  data() {
    return {
      keyword: '',
      loading: false,
      finished: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2100, 0, 31),
      areas: {
        datagram: areaList,
        visible: false,
        name: '威海市',
        code: ''
      },
      formFilter: {
        type: '1',//查询类型
        department: '',
        stage: '',
        calendar: ''
      },
      pageNo: 1,
      form: {
        blzt: 1,
        itemName: undefined,
        orgName: undefined,
        stageId: undefined,
        startTime: undefined,
        endTime: undefined,
      },
      department: '371000000000',
      typeRadio: [
        { text: '接件至办结', value: 1 },
        { text: '受理至办结', value: 3 },
        { text: '部门开始办理至办结', value: 8 },
      ],
      stageRadio: [
        { id: '1', name: '立项用地规划许可' },
        { id: '2', name: '工程建设许可' },
        { id: '3', name: '施工许可' },
        { id: '4', name: '竣工验收' }
      ],
      listData: [
        {
          id: '1',
          label: '用地规划许可证（核发）',
          time: '77s',
          title: '威海翠万达城市综合体东块',
          code: '2019-371002-70-03-020271',
          department: '业务科',
          accept: '2024-7-12 8：43',
          completed: '2024-7-12 8：44'
        }, {
          id: '2',
          label: '用地规划许可证（核发）',
          time: '77s',
          title: '威海翠万达城市综合体东块',
          code: '2019-371002-70-03-020271',
          department: '业务科',
          accept: '2024-7-12 8：43',
          completed: '2024-7-12 8：44'
        },
      ],
      regionList: []
    }
  },
  methods: {
    handleAreaConfirm(val) {
      const that = this
      const { name, code } = val[val.length - 1]
      that.areas.name = name
      that.areas.code = code
      that.areas.visible = false
    },
    handleAreaCancel(val) {
      const that = this
      that.areas.visible = false
    },
    confirmCalendar(date) {
      const [start, end] = date
      this.form.startTime = moment(start).format('YYYY-MM-DD')
      this.form.endTime = moment(end).format('YYYY-MM-DD')
      this.$refs.refItemCalendar.toggle()
    },
    getDataList() {
      const instance = wfzbj({
        blzt: this.form.blzt,
        itemName: this.keyword,
        orgName: this.form.orgName,
        stageId: this.form.stageId,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        page: this.pageNo++,
        rows: window.config.pageSize
      })
      instance
        .then((result) => {
          const data = result.data.rows.map(item => {
            let temp = item.cell
            temp.startTime = moment(temp.START_TIME).format('YYYY-MM-DD HH:mm:ss')
            temp.completed = moment(temp.FINISH_TIME).format('YYYY-MM-DD HH:mm:ss')
            return temp
          })
          if (data.length > 0) {
            this.listData = this.listData.concat(data)
            this.loading = false
            this.finished = false
          } else {
            this.$dialog.alert({
              message: '没有更多数据了'
            })
            this.loading = false
            this.finished = true
          }
        }).catch((err) => {
          console.log(err);
          this.$dialog.alert({
            message: '请求失败请联系开发人员'
          })
          this.loading = false
          this.finished = true
        });
    },
    regionChange(picker, values) {
      if (values[0].value == this.department) {
        this.form.orgName = values[1].name
      } else {
        this.department = values[0].value
        this.getDepartments()
      }
    },
    getDepartments() {
      var loadingInstance = Loading.service({ target: 'department1' });
      const instance = getOrgInfo({ regionCode: this.department })
      instance
        .then((result) => {
          const data = JSON.parse(result.data.data)
          data.forEach(item => item.name = item.NAME)
          this.regionList = data
          loadingInstance.close()
        }).catch((err) => {
          console.log(err);
        });
    },
    onClick1({ item }) {
      if (item.TYPE == 'region') {
        this.department = item.CODE
        this.getDepartments()
      } else {
        this.form.orgName = item.NAME
        this.regionList = []
        this.$refs.department.toggle()
      }
    },
    onComfirm1() { },
    close1() {
      this.form.orgName = undefined
      this.department = '371000000000'
      this.getDepartments()
    },
  },
  mounted() {
    this.getDepartments()
  },
  watch: {
    keyword: {
      handler: _.debounce(function (newVal) {
        this.pageNo = 1
        this.listData = []
        this.getDataList()
      }, 500),
      immediate: true
    },
    form: {
      handler: _.debounce(function (newVal) {
        this.pageNo = 1
        this.listData = []
        this.getDataList()
      }, 500),
      deep: true
    }
  }
}
</script>
  
<style lang="less" scoped>
.van-page {
  padding-bottom: 60px;
}

.van-container {
  padding: 12px 16px;
}

::v-deep {
  .search-box {
    .van-search__label {
      display: inline-flex;
      align-items: center;
      padding: 0;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        height: 16px;
        width: 1px;
        background: #D9DADE;
        right: 5px;
      }

      .van-button {
        margin-left: 2px;
        height: 26px;
        padding: 0 8px;
        font-size: 12px;
        border: 0;

        .van-button__text {
          display: inline-flex;
          align-items: center;
        }

        .van-icon {
          margin-right: -4px;
        }
      }
    }

    .van-search__content {
      padding: 0;
      border: 1px solid #EAEBEE;
      background: #fff;
      // height: 30px;
    }
  }
}

::v-deep {
  .van-filter {
    background: #fff;
    padding: 0 12px 16px;
    display: flex;
    align-items: center;
  }

  .van-dropdown-menu__bar {
    height: 32px;
  }

  .van-dropdown-menu__item {
    background: #F3F3F4;
    flex: none;
    padding-right: 15px;

    &+.van-dropdown-menu__item {
      margin-left: 8px;
    }
  }

  .van-dropdown-menu__title {
    font-size: 12px;

    &:after {
      border-color: transparent transparent #BDBFC6 #BDBFC6;
    }
  }
}

::v-deep {
  .popup-body {
    padding: 12px 12px;
  }

  .van-radio-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: -4px -4px 4px -4px;

    .van-radio {
      padding: 4px;
      width: 25%;
      overflow: hidden;

      .van-radio__label {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
        margin: 0;
        text-align: center;
        background-color: #F3F3F4;
        font-size: 12px;
        border-radius: 2px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      .van-radio__icon {
        display: none;

        &.van-radio__icon--checked+.van-radio__label {
          color: #427AF4;
          background: #E3EFFF;
        }
      }
    }
  }

  .van-section {
    margin-bottom: 12px;
    background: #fff;
    margin-bottom: 12px;

    .van-cell {
      padding-top: 0px;
      // padding-bottom: 8px;
    }

    .van-cell__title {
      flex: none;
      color: #868A93;
      width: 70px;
    }

    .van-cell__value {
      text-align: left;
    }
  }

  .van-section__header {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .van-section__title {
    font-size: 12px;
    font-weight: 600;
    width: 80%;
  }

  .van-section__time {
    color: #868997;
    font-size: 12px;
    width: 18%;

    em {
      color: #427AF4;
      font-style: normal;
    }
  }
}

.text-black {
  color: #000;
}

::v-deep {
  .van-color-primary {
    color: #32ae57
  }

  .van-bgcolor-primary {
    background-color: #32ae57
  }

  .van-color-success {
    color: #00982d
  }

  .van-bgcolor-success {
    background-color: #00982d
  }

  .van-color-danger {
    color: #ff5f4e
  }

  .van-bgcolor-danger {
    background-color: #ff5f4e
  }

  .van-color-warning {
    color: #ff7b35
  }

  .van-bgcolor-warning {
    background-color: #ff7b35
  }

  .van-color-info {
    color: #0283ef
  }

  .van-bgcolor-info {
    background-color: #0283ef
  }

  .van-color-text-primary {
    color: #111
  }

  .van-bgcolor-text-primary {
    background-color: #111
  }

  .van-color-text-regular {
    color: #333
  }

  .van-bgcolor-text-regular {
    background-color: #333
  }

  .van-color-text-assist {
    color: #666
  }

  .van-bgcolor-text-assist {
    background-color: #666
  }

  .van-color-text-secondary {
    color: #999
  }

  .van-bgcolor-text-secondary {
    background-color: #999
  }

  .van-color-text-placeholder {
    color: #b2b2b2
  }

  .van-bgcolor-text-placeholder {
    background-color: #b2b2b2
  }

  .van-color-text-empty {
    color: #6c7d8f
  }

  .van-bgcolor-text-empty {
    background-color: #6c7d8f
  }

  .van-color-border-color {
    color: #cdcdcd
  }

  .van-bgcolor-border-color {
    background-color: #cdcdcd
  }

  .van-color-line-color {
    color: #e2e2e2
  }

  .van-bgcolor-line-color {
    background-color: #e2e2e2
  }

  .van-color-background-color {
    color: #f6f6f6
  }

  .van-bgcolor-background-color {
    background-color: #f6f6f6
  }

  .van-color-white {
    color: #fff
  }

  .van-bgcolor-white {
    background-color: #fff
  }

  .van-color-black {
    color: #000
  }

  .van-bgcolor-black {
    background-color: #000
  }

  .van-color-transparent {
    color: transparent
  }

  .van-bgcolor-transparent {
    background-color: transparent
  }

  .van-cascade-select {
    line-height: 1.5;
    background: #fff
  }

  .van-cascade-select__header {
    padding: 12px 40px 12px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    font-size: 16px;
  }

  .van-cascade-select__close {
    color: #999;
    position: absolute;
    right: 14px;
    font-size: 12px
  }

  .van-cascade-select__title {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex
  }

  .van-cascade-select__title-text {
    color: #666;
    padding-left: 14px;
    padding-right: 6px;
    font-size: 15px;
  }

  .van-cascade-select__placeLine {
    display: block;
    height: 24px
  }

  .van-cascade-select__placeholder {
    color: #111;
    font-weight: 700;
    margin-left: 14px
  }

  .van-cascade-select__line {
    position: relative;
    top: 9px;
    z-index: 1;
    width: 55px;
    height: 3px;
    background-color: #32ae57;
    border-radius: 1.5px
  }

  .van-cascade-select__wrapper {
    overflow: auto;
    color: #333;
    padding: 4px 0 12px 14px
  }

  .van-cascade-select__item {
    padding: 10px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    font-size: 16px;
    align-items: center
  }
}
</style>
